import { createAsyncThunk } from '@reduxjs/toolkit'
import { fetchFun } from '../../../../utils/fetchFun';
import { getUniqeRowsHandler, uniqueRowsFormatter } from '../../../../pages/cfs/utils/helperFunctions';
import { transformGlQbRows } from '../../../../utils/transformGlQbRows';


export const fetchBeginningBalances = createAsyncThunk(
    'user/fetchBeginningBalances',
    async ({user}) => {
		try{
			const beginningBalances = await fetchFun(`/api/v1/cfs/beginningBalances/${user._id}`);
			if(beginningBalances?.success) {
                return beginningBalances.data
            }
			
		} catch (error) {
			console.log("Error - /beginningBalances", error)
		}
    }
);

export const fetchMMMSplitSavedEntries = createAsyncThunk(
    'user/fetchMMMSplitSavedEntries',
    async ({user}) => {
		try{
			const MMMSplitSavedEntries = await fetchFun(`/api/v1/cfs/MMSplitEntries/${user._id}`);
			if(MMMSplitSavedEntries?.success) {
                return MMMSplitSavedEntries.data
            }
			
		} catch (error) {
			console.log("Error - /MMSplitEntries", error)
		}
    }
);

export const fetchCfsReports = createAsyncThunk(
    'user/fetchCfsReports',
    async ({user}) => {
        try {
            const cfsReports = await fetchFun(`/api/v1/cfs/reports/${user._id}`);
            if(cfsReports?.success) {
                return cfsReports.data
            }
        } catch(error) {
            console.log("Error - /reports", error)
        }
    }
)

export const regenerateCfsReports = createAsyncThunk(
    'user/regenerateCfsReports',
    async (userId) => {
        try {
            const cfsReports = await fetchFun(`/api/v1/cfs/regenerateCfs/${userId}`, 'POST');
            if(cfsReports?.success) {
                return cfsReports.data
            }
        } catch(error) {
            console.log("Error - /regenerateCfs", error)
        }
    }
)

export const fetchGeneralLedgerData = createAsyncThunk(
    'user/fetchGeneralLedgerData',
    async ({user}) => {
        try {
            const glData = await fetchFun(`/api/v1/cfs/glReports/${user?._id}`, 'GET');
            if(glData?.success) {
                const periods = {
                    periodOne: transformGlQbRows(glData?.data?.generalLedgerReports?.[0]?.qbData) || null,
                    periodTwo: transformGlQbRows(glData?.data?.generalLedgerReports?.[1]?.qbData) || null
                };
                return periods
            }
        } catch(error) {
            console.log("Error - /glReports", error)
        }
    }
)

export const fetchRawJournalData = createAsyncThunk(
    'user/fetchRawJournalData',
    async ({user}) => {
        try {
            const rjData = await fetchFun(`/api/getJournalReport/${user?._id}`, 'GET');
            if(rjData?.success) {
                let periods = {
                    periodOne: null,
                    periodTwo: null
                };
                const p1data = !!rjData?.data?.periodOneData?.journalReport?.qbData ? rjData.data.periodOneData?.journalReport?.qbData.Rows.Row.filter(row=> !!row?.ColData  && !!row?.ColData?.[1].id) : null;
                const p2data = !!rjData?.data?.periodTwoData?.journalReport?.qbData ? rjData.data.periodTwoData?.journalReport?.qbData.Rows.Row.filter(row=> !!row?.ColData  && !!row?.ColData?.[1].id) : null;
                if(p1data){
                    const entryWiseData = getUniqeRowsHandler(p1data);
                    const formatedData = uniqueRowsFormatter(entryWiseData);
                    periods.periodOne = formatedData || null;         
                    // setJournalData(prev => ({...prev, periodOne: formatedData}));
                }
                if(p2data){
                    const entryWiseData = getUniqeRowsHandler(p2data);
                    const formatedData = uniqueRowsFormatter(entryWiseData);
                    periods.periodTwo = formatedData || null;
                    
                    // setJournalData(prev => ({...prev, periodTwo: formatedData}));                      
                }
                return periods
            }
        } catch(error) {
            console.log("Error - /getJournalReport", error)
        }
    }
)